import { FieldErrors, FieldValues, FieldError } from 'react-hook-form'

export function getErrorMessage<TFieldValues extends FieldValues>(
  path: string,
  errors: FieldErrors<TFieldValues>
): string | undefined {
  const error = path
    .split('.')
    .reduce<unknown>(
      (acc, key) =>
        acc && typeof acc === 'object' && key in acc
          ? (acc as Record<string, unknown>)[key]
          : undefined,
      errors
    ) as FieldError | undefined

  return error?.message // Acessa explicitamente a mensagem
}
